import { useHistory } from 'react-router-dom';
import { useCallback } from 'react';
import { useCurrentKnowledgeBaseId } from '../../knowledge-base/hooks/knowledgeBaseHooks';
import useCrmObjectTypeListingFilters from 'framework-listing-lib/hooks/useCrmObjectTypeListingFilters';
import { useListingLibQuickFilters } from 'framework-listing-lib/hooks/useQuickFilters';
import KnowledgeBaseSelectWrapper from './KnowledgeBaseSelectWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const ContentKnowledgeBaseSwitcher = () => {
  const history = useHistory();
  const currentKnowledgeBaseId = useCurrentKnowledgeBaseId();
  const {
    quickFilters,
    removeQuickFilter
  } = useListingLibQuickFilters();
  const {
    onClearFilters
  } = useCrmObjectTypeListingFilters();
  const {
    onRemovePropertyFilter
  } = useCrmObjectTypeListingFilters();
  const clearAllFilters = useCallback(() => {
    onClearFilters();
    quickFilters.forEach(filter => {
      removeQuickFilter(filter.property);
      onRemovePropertyFilter(filter.property);
    });
  }, [onClearFilters, onRemovePropertyFilter, quickFilters, removeQuickFilter]);
  const handleSelectKnowledgeBase = useCallback(newKnowledgeBaseId => {
    if (currentKnowledgeBaseId) {
      clearAllFilters();
      const updatedPathName = history.location.pathname.replace(`${currentKnowledgeBaseId}`, `${newKnowledgeBaseId}`);
      history.push(updatedPathName);
    }
  }, [currentKnowledgeBaseId, clearAllFilters, history]);
  return /*#__PURE__*/_jsx(KnowledgeBaseSelectWrapper, {
    onSelectKnowledgeBase: handleSelectKnowledgeBase
  });
};
export default ContentKnowledgeBaseSwitcher;